import { api } from ":mods";
import { ENDPOINTS } from "../const";
import { OTPProps } from "../models";

export async function patchAccountOtp(data: OTPProps) {
  return api
    .patch(ENDPOINTS.patch_account_otp, data)
    .then(async (res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}
